import { myAxios } from "./axios"

export function getPayslipes({filters}, { page, perPage }) {
    let config = {
        params: {
            page,
            perPage,
            ...(filters || {})

        },
    }
    return myAxios.get("/payslipes", config)
}

export function getEmployeePayslipes({employeeId, filters}, { page, perPage }) {
    let config = {
        params: {
            page,
            perPage,
            ...(filters || {})
            
        },
    }
    return myAxios.get("/employees/"+employeeId+"/payslipes", config)
}

export function getPayslipe(id) {
    return myAxios.get("/payslipes/" + id)
}

export function addPayslipe(data) {
    return myAxios.post("/payslipes/create", data)
}

export function editPayslipe(id, data) {
    return myAxios.put("/payslipes/" + id + "/update", data)
}

export function deletePayslipe(id) {
    return myAxios.delete("/payslipes/" + id + "/delete")
}


export function payPayslipe(data) {
    return myAxios.post("/payslipes/pay", data)
}

export function exportPendingPayslipes() {
    return myAxios.get("/payslipes/export")
}
export function exportPendingEmployeePayslipe(id) {
    return myAxios.get("/payslipes/export/"+id)
}

export function getPayslipPdf(id, data) {
    return myAxios.post("/payslipes/" + id + "/create-pdf", data, {
      responseType: 'blob'
    });
}